module.exports = __webpack_public_path__ + "img/mars-mission.7e0d0609.jpg";